import React, { useState } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { BookOpen, ChevronDown, ChevronUp } from 'lucide-react';

const DocsPage = () => {
  const { t } = useLanguage();
  const DOCS = t('docs.categories');
  const [openSections, setOpenSections] = useState({});

  const toggleSection = (catIndex, itemIndex) => {
    const key = `${catIndex}-${itemIndex}`;
    setOpenSections((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-white rounded-full shadow-lg mb-4">
            <BookOpen className="w-8 h-8 text-purple-600" />
          </div>
          <h1 className="text-4xl font-bold text-white mb-2">{t('docs.title')}</h1>
          <p className="text-lg text-white/90">
            {t('docs.subtitle')}
          </p>
        </div>

        <div className="space-y-6">
          {DOCS.map((category, catIndex) => (
            <div key={catIndex} className="card">
              <h2 className="text-xl font-bold text-gray-800 mb-4 flex items-center space-x-2">
                <span className="w-2 h-2 bg-purple-500 rounded-full"></span>
                <span>{category.category}</span>
              </h2>

              <div className="space-y-2">
                {category.items.map((item, itemIndex) => {
                  const key = `${catIndex}-${itemIndex}`;
                  const isOpen = openSections[key];

                  return (
                    <div
                      key={itemIndex}
                      className="border border-gray-200 rounded-lg overflow-hidden"
                    >
                      <button
                        onClick={() => toggleSection(catIndex, itemIndex)}
                        className="w-full flex items-center justify-between p-4 hover:bg-gray-50 transition-colors text-left"
                      >
                        <span className="font-semibold text-gray-800">{item.title}</span>
                        {isOpen ? (
                          <ChevronUp className="w-5 h-5 text-gray-500 flex-shrink-0" />
                        ) : (
                          <ChevronDown className="w-5 h-5 text-gray-500 flex-shrink-0" />
                        )}
                      </button>
                      {isOpen && (
                        <div className="px-4 pb-4 text-sm text-gray-600 leading-relaxed border-t border-gray-100 pt-3">
                          {item.content}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DocsPage;
